<template>
  <address-props :value="value" :address-name="addressName" :movable="movable" @move="moved" mod-map :mod-props="!editing">
    <po-action-dropdown v-if="!currentAction" :actions="actions" slot="actions" @execute="executeAction" mod-right />
    <po-slot-switcher :value="currentAction">
      <wo-region slot="lookup">
        <wo-layout>
          <po-input-field v-model="searchText" placeholder-key="address.lookupPlaceholder" v-focus="modFocus" :mod-error="lookupError" />
          <po-confirmation-buttons @confirm="doLookup" @cancel="clearAction" labelKey="general.action.lookup" :valid="searchText" />
        </wo-layout>
      </wo-region>
      <wo-region slot="move">
        <wo-layout>
          <wo-typography>
            <p v-t="'address.movePinMessage'"></p>
          </wo-typography>
          <po-confirmation-buttons @confirm="doMove" @cancel="clearAction" labelKey="general.action.confirm" :valid="true" />
        </wo-layout>
      </wo-region>
    </po-slot-switcher>
  </address-props>
</template>

<script>

import { Actions } from '@/model/util'
import { Address } from '@/model/company'

import { locate } from '@/repository/geography'

import { showModal } from '@/modal'

import AddressProps from '@/components/geography/AddressProps'
import AddressEditModal from '@/components/geography/AddressEditModal'

const lookup = Actions.create('lookup', 'address.action.lookup', 'magnifier')
const move = Actions.create('move', 'address.action.movePin', 'marker')
const edit = Actions.create('edit', 'address.action.editManual', 'gear')

export default {
  components: { AddressProps },
  props: {
    value: Address,
    addressName: String,
    modFocus: Boolean
  },
  data () {
    return {
      searchText: undefined,
      currentAction: undefined,
      lookupError: false,
      pendingMove: undefined
    }
  },
  computed: {
    actions () {
      return this.value && [lookup, move, edit]
    },
    movable () {
      return this.currentAction === move
    },
    editing () {
      return this.currentAction === edit
    }
  },
  watch: {
    editing () {
      if (this.editing) {
        showModal(AddressEditModal, { value: this.value, modLg: true })
          .then(address => this.doEdit(address))
          .catch(e => this.clearAction())
      }
    }
  },
  created () {
    if (!this.value) {
      this.executeAction(lookup)
    }
  },
  methods: {
    clearAction () {
      this.searchText = undefined
      this.currentAction = undefined
    },
    executeAction (action) {
      this.currentAction = action
    },
    doLookup ({ detail }) {
      this.lookupError = false
      locate(this.$store, this.searchText)
        .then(address => {
          if (address) {
            this.$emit('input', address)
            this.clearAction()
          } else {
            this.lookupError = true
          }
        })
        .finally(detail.resolve)
    },
    moved (coordinates) {
      this.pendingMove = coordinates
    },
    doMove () {
      const address = Object.assign(new Address(this.value), this.pendingMove)
      this.$emit('input', address)
      this.clearAction()
    },
    doEdit (address) {
      this.$emit('input', address)
      this.clearAction()
    }
  }
}
</script>
